<script lang="ts">
  import {
    Column,
    FormGroup,
    FormLabel,
    Grid,
    ImageLoader,
    InlineNotification,
    Link,
    Row,
  } from "carbon-components-svelte";
  import { productId } from "../../../ts/Stores";
  import { NCFields } from "../../../ts/NCFields";
  import CallToAction from "../CallToAction.svelte";
  import type { RubberStampResult } from "src/ts/Classes";

  export let product: RubberStampResult = null;
  export let stampCategory: string = null;
  export let stampType: string = null;

  let ncfields = NCFields.Instance();
  let ProductId: string = null;
  productId.subscribe((value) => {
    ProductId = value;
  });
</script>

{#if product}
  <FormGroup
    legendText="Best matched product for your design"
    class="step"
    noMargin
  >
    <InlineNotification
      kind="info"
      title="Stamp size -"
      subtitle="Width: {Math.trunc(
        product.productWidth,
      )} mm, Height: {Math.trunc(product.productHeight)} mm"
      hideCloseButton
    />
    <div class="pane">
      <Grid noGutter>
        <Row>
          <Column sm={8} md={6} lg={6}>
            <ImageLoader src={product.productPicturePath} />
          </Column>
          <Column sm={8} md={10} lg={10}>
            <div class="variant-overview">
              <div id="matchedProduct" class="variant-name">
                {product.productName}
              </div>
              <div class="sku">SKU:{product.productSKU}</div>
              <span class="product-price">{product.productPrice}</span>
            </div>
            <!-- <span class="old-product-price">{product.productOldPrice}</span> -->
          </Column>
        </Row>
      </Grid>

      <CallToAction
        editMode={ncfields.editMode && !ncfields.hasProductChanged(ProductId)}
        {ProductId}
      />

      {#if stampCategory === "Rubber Stamp" && stampType === "Traditional"}
        <InlineNotification kind="info" title="Please Note">
          For traditional rubber stamps, inks and pads are sold separately to
          view our range click here - <Link href="/stamp-pads">Pads & Ink</Link>
        </InlineNotification>
      {/if}

      {#if ncfields.editMode}
        {#if ncfields.hasProductChanged(ProductId)}
          <InlineNotification kind="warning" title="Product Selection Changed!">
            Please note that the edited design requires a different product than
            previously selected. If you wish to continue with this design, the
            previously product should be removed from the cart.
          </InlineNotification>
        {/if}
      {/if}
    </div>
  </FormGroup>
{/if}
